"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsPage = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../app");
const settings_1 = require("../../model/settings");
const form_for_1 = require("../../widgets/form_for");
const notification_center_1 = require("../../widgets/notification_center");
let settings = {};
exports.OptionsPage = {
    oncreate() {
        settings_1.SettingsProvider.show(0).then((data) => {
            settings = data;
        });
    },
    view() {
        return (0, mithril_1.default)(".container", (0, mithril_1.default)(".content", (0, mithril_1.default)("h2", "Paramètres de l'application"), (0, mithril_1.default)("hr"), (0, form_for_1.formFor)(settings, settings_1.SettingsProvider, (form) => {
            return (0, mithril_1.default)("div", (0, form_for_1.fieldset)("Informations de contact", {}, (0, form_for_1.columns)(form.field("Numéro de telephone du Centre Sésame", "phone_number", "text"), form.field("E-mail du Centre Sésame", "email", "email")), form.textarea("Adresse du Centre Sésame", "address", {}), form.textarea("Texte de signature pour les emails (HTML)", "signature")), (0, form_for_1.fieldset)("Informations financières", {}, (0, form_for_1.columns)(form.field("Taux de TVA", "vat_rate", "number"), form.field("Seuil de rentabilité", "rentability_threshold", "number"))), (0, form_for_1.fieldset)("Autres", {}, form.field("Lien vers formulaire de création de forfait", "new_contract_request_link", "text"), form.field("Code de la porte (1)", "door_code_building", "text"), form.field("Code de la porte (Porte vitrée)", "door_code_building_2", "text")), form.submit("Mettre à jour", {
                onsubmit: () => {
                    app_1.App.reloadSettings();
                    notification_center_1.Notification.info("Les paramètres de l'application ont bien été mis à jour");
                }
            }), (0, mithril_1.default)("hr"));
        })));
    }
};
